import {
  TextField,
  FormControl,
  Checkbox,
  Select,
  FormControlLabel,
  InputLabel,
  FormLabel,
  FormGroup,
  Radio
} from '@mui/material'

export const renderInputField = ({ input, label, meta: { touched, error }, ...custom }) => (
  <FormControl variant='filled' fullWidth={true} style={{ margin: '0 0 10px 0' }}>
    <TextField label={label} variant='filled' error={touched && !!error} {...input} {...custom} autoComplete='off' />
  </FormControl>
)

export const renderSelectField = ({ input, meta: { touched, error }, onChangeCountry, label, children }) => {
  return (
    <FormControl variant='filled' fullWidth={true} style={{ margin: '0px 0px 20px 0px' }}>
      <InputLabel error={touched && !!error}>{label}</InputLabel>
      <Select
        id={label}
        name={label}
        value={input.value.toLowerCase()}
        error={touched && !!error}
        onChange={(data) => {
          if (onChangeCountry) {
            onChangeCountry(data.target.value)
          }
          input.onChange(data.target.value)
        }}
      >
        {children}
      </Select>
    </FormControl>
  )
}

export const renderCheckBox = (data) => {
  const { input, label, meta } = data
  return (
    <FormControl required error={!!meta.error} component='fieldset'>
      <FormGroup>
        <FormControlLabel style={{ marginTop: 8 }} control={<Checkbox {...input} type='checkbox' />} label={label} />
        {meta.touched && !!meta.error && <FormLabel component='legend'>Required</FormLabel>}
      </FormGroup>
    </FormControl>
  )
}

export const renderRadioButton = ({ input: { onChange, ...input }, label }) => (
  <FormControlLabel {...input} onChange={(value) => onChange(value)} control={<Radio />} label={label} value={label} />
)

export const renderTextField = (data) => {
  return (
    <TextField
      {...data.input}
      minRows={5}
      maxRows={5}
      placeholder={data.label}
      style={{ width: '100%', background: '#222222', color: 'white' }}
      multiline
      autoComplete='off'
      label={data.label}
      error={data.error}
    />
  )
}
